import Controller from '@ember/controller';
import { action } from '@ember/object';
import { service } from '@ember/service';
import { tracked } from '@glimmer/tracking';

export default class ResourcesRolesController extends Controller {
  @service intl;
  queryParams = ['grouping'];

  @tracked grouping = null;

  get groupingOptions() {
    return [
      {
        label: this.intl.t('roles.person', {
          num: 3,
        }),
        value: 'person',
      },
    ];
  }

  get roles() {
    return this.model.slice();
  }

  @action
  setGrouping(e) {
    this.grouping = e.value;
  }
}
